import { IVisibleLogic } from 'config'

export enum UwSummarySection {
  UnderwritingInformation = 'UnderwritingInformation',
  PropertyConstruction = 'PropertyConstruction',
  BorrowerCreditInfo = 'BorrowerCreditInfo',
  BorrowerInterestSource = 'BorrowerInterestSource',
  SeniorLienInformation = 'SeniorLienInformation',
  Exception = 'Exception',
}

export type IUwSummaryFieldConfig = {
  visible?: boolean
  required?: boolean
  visibleLogic?: IVisibleLogic[][]
}

export type IUwSummaryConfig = Record<UwSummarySection, Record<string, IUwSummaryFieldConfig>>

export const UwSummarySectionText: Record<UwSummarySection, string> = {
  [UwSummarySection.UnderwritingInformation]: 'Underwriting Information',
  [UwSummarySection.PropertyConstruction]: 'Property/Construction',
  [UwSummarySection.BorrowerCreditInfo]: 'Borrower Credit/Info',
  [UwSummarySection.BorrowerInterestSource]: 'Source of Borrowers Interest In Subject Property',
  [UwSummarySection.SeniorLienInformation]: 'Senior Lien Information',
  [UwSummarySection.Exception]: 'Exception',
}

export const inputGroups: Record<UwSummarySection, string[]> = {
  [UwSummarySection.UnderwritingInformation]: [
    'InvestorCode',
    'OriginationChannel',
    'DocumentType',
    'DocumentName',
    'Borrower_Reserves',
    'PropertyClass',
    'ManufacturedHomeSecuredPropertyType',
    'ManufacturedHomeLandPropertyInterest',
    'ProjectName',
    'SellerCredit',
    'EarnestMoneyAmount',
    'PROJ250_AccrualType',
    'MedianHomePrice',
    'AIV2MedianRate',
    'ARV2MedianRate',
    'Mers',
    'InterestType',
    'ExceptionTitle',
    'DisclosedLitigation',
    'PROJ250DealNarrative',
    'constructionCompanyAddressMap',
  ],
  [UwSummarySection.PropertyConstruction]: [
    'PROJ250_Construction',
    'PROJ250_IsNewConstruction',
    'PROJ250_NewAcquisition',
    'PROJ250_PropertyYouAlreadyOwn',
    'PROJ250_PropertyAcquisitionDate',
    'PROJ250_ConstructionCompletionDate',
    'Company',
    'FullName',
    'FullAddress',
    'ContractDate',
    'CurrentSQFT',
    'AfterRehadSQFT',
    'BedroomCount',
    'BathroomCount',
    'LotSize',
    'YearBuilt',
    'purchaseDate',
    'purchasePrice',
    'numberOfUnits',
    'asIsPerUnit',
    'arvPerUnit',
    'msa',
    'numberOfProperties',
    'experience',
    'Strategy',
    'RentSource',
    'RentFromLease',
    'RentFromMarketSurvey',
    'AsIsValue',
    'AsIsAppraisedValue',
    'AfterRepairValue',
    'AfterRepairAppraisedValue',
    'MarketRent',
    'MonthlyRent',
  ],
  [UwSummarySection.BorrowerCreditInfo]: [
    'NonQMHouseholdSize',
    'BorrowerLifetimeProjects',
    'BorrowerExperiencewithOriginator',
  ],
  [UwSummarySection.BorrowerInterestSource]: [
    'BorrowersInterestSourceTypeInSubjectProperty',
    'BorrowersInterestSourceTitleInSubjectProperty',
    'RecordingInfo',
    'BorrowersInterestSourceDateInSubjectProperty',
    'DeedRecordingDate',
  ],
  [UwSummarySection.SeniorLienInformation]: [
    'SRLenderName',
    'SRDOTRecDate',
    'SRDOTInstrumentNo',
    'SRLoanAmount',
    'SRTrusteeName',
  ],
  [UwSummarySection.Exception]: [
    'HasException',
    'ExceptionType',
    'ExceptionDetail',
    'ExceptionRequestedDate',
    'ExceptionApprovedDate',
    'ExceptionApprover',
    'ExceptionApproved',
  ],
}
